<script>
export default {
  name: "sidebar-component",
  data() {
    return {
      defaultProps: {
        children: "children",
        label: function (data) {
          return data.parent.menuName;
        },
      },
    };
  },
  computed: {
    loginSidebar() {
      return this.$store.state.loginSidebar;
    },
  },
  methods: {
    handleNodeClick(data) {
      if (!data.parent.url) return;
      if (this.$route.name === data.parent.url) return;
      // console.log(this.$route.name);
      this.$router.push({ name: data.parent.url });
      // console.log(data.parent.url);
    },
  },
  async mounted() {
    // await this.$store.dispatch("qrySideBar");
  },
};
</script>

<template src="./Sidebar.html"></template>
<style lang="sass" scoped src="./Sidebar.sass"></style>
